import Constants from '../constants'

export default {
   DEVICE_URL: Constants.BASE_URL + '/device'
}

export const Actions = {
   create: 'device:create',
   update: 'device:update',
   list:   'device:list',
   change: 'device:change'
}



// WEBPACK FOOTER //
// lib/api/device/Constants.js